var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.9067179,11.7891254 L13.9067179,18.5090575 C13.9067179,18.6471287 13.7947891,18.7590575 13.6567179,18.7590575 C13.6038823,18.7590575 13.5524051,18.7423179 13.509675,18.7112415 L11.259675,17.0748779 C11.1949889,17.0278335 11.1567179,16.952678 11.1567179,16.8726939 L11.1567179,12.0447916 L5.10418665,6.18018546 C5.00502833,6.08410591 5.00253249,5.92583435 5.09861204,5.82667602 C5.14474052,5.77906941 5.20788794,5.75173201 5.27416848,5.75067521 L19.7495784,5.5198742 C19.8876321,5.51767303 20.0013311,5.62780321 20.0035322,5.76585685 C20.0046324,5.83486008 19.9771597,5.90124878 19.9276216,5.94929703 L13.9067179,11.7891254 Z","id":"path-1"}));
}

Filter.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","fill":"currentColor","version":"1.1"};

module.exports = Filter;

Filter.default = Filter;
